module.exports = __webpack_public_path__ + "static/media/norway.c3627838.svg";